import { apiSlice } from '../../api/slice'

export const userApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    registerLead: builder.mutation({
      query: ({ email }) => ({
        url: `/user/lead`,
        method: 'POST',
        body: { email },
      }),
    }),
    verifyEmail: builder.mutation<any, any>({
      query: (body) => ({
        url: `/auth/email/verify`,
        method: 'POST',
        body,
      }),
    }),
    getDropsRewards: builder.query<any, any>({
      query: () => ({
        url: `/drops/rewards/all`,
        method: 'GET',
      }),
    }),
    claimRewardsSignature: builder.mutation<any, any>({
      query: ({ parentDropId }) => ({
        url: `/drops/claimReward/signature/${parentDropId}`,
        method: 'POST',
      }),
    }),
    claimRewardsHistory: builder.mutation<any, any>({
      query: ({ body }) => ({
        url: `/drops/claimReward/history`,
        method: 'POST',
        body,
      }),
    }),
    toggleIsPublicTrades: builder.mutation<any, any>({
      query: ({ body }) => ({
        url: `/user/memecoins/toggle-is-public-trades`,
        method: 'PATCH',
        body,
      }),
    }),
    refreshTwitterProfile: builder.mutation<any, any>({
      query: ({ body }) => ({
        url: `/auth/twitter/refresh`,
        method: 'PUT',
        body,
      }),
    }),
    editProfile: builder.mutation<any, any>({
      query: ({ userName }) => ({
        url: `/user/edit-profile`,
        method: 'PUT',
        body: { userName },
      }),
    })
  }),
})

export const {
  useRegisterLeadMutation,
  useVerifyEmailMutation,
  useGetDropsRewardsQuery,
  useLazyGetDropsRewardsQuery,
  useClaimRewardsSignatureMutation,
  useClaimRewardsHistoryMutation,
  useToggleIsPublicTradesMutation,
  useRefreshTwitterProfileMutation,
  useEditProfileMutation,
} = userApiSlice
